import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card } from './ui/card';

export const WhoWeAre = () => {
  const highlights = [
    'Registered GeM Seller',
    'Trusted Technology Brands',
    'Structured Procurement',
    'Reliable Delivery'
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-6">
            Who We Are
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto">
            Brahmaputra Infotech is a technology procurement and solutions company based in Guwahati, Assam, serving government departments, institutions, and enterprises.
          </p>
        </div>

        <Card className="p-8 bg-white border-none shadow-lg">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {highlights.map((item, index) => (
              <div key={index} className="flex items-center space-x-3">
                <CheckCircle2 className="text-teal-600 flex-shrink-0" size={24} />
                <span className="text-gray-800 font-medium">{item}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
};